var exports = {
  "vK": "xe7b6e3d6--6807e6--banner",
  "eU": "xe7b6e3d6--6807e6--logo-and-banks",
  "wm": "xe7b6e3d6--6807e6--logo",
  "e4": "xe7b6e3d6--6807e6--banks",
  "n1": "xe7b6e3d6--6807e6--circle",
  "DH": "xe7b6e3d6--6807e6--bank-logo",
  "Ji": "xe7b6e3d6--6807e6--payment",
  "x6": "xe7b6e3d6--6807e6--button",
};

module.exports = exports;
